import { Injectable } from '@angular/core';

interface IStepper {
  total: number;
  current: number;
  hidden: boolean
}

@Injectable({
  providedIn: 'root'
})
export class StepperService {
  stepper: IStepper = {
    total: null,
    current: null,
    hidden: true
  }

  constructor() { }

  setStepper( stepper: IStepper ) {
    this.stepper = stepper
  }

  setCurrent( step: number ) {
    this.showStepper();
    this.stepper.current = step
  }

  hideStepper() {
    this.stepper.hidden = true;
  }
  
  showStepper() {
    this.stepper.hidden = false;
  }

}
